import { TowerPaymentsPairFormProvider } from "./TowerPaymentsPairFormProvider";
import {
  Card,
  ControlledTextField,
  Stack,
} from "@towersystems/roam-common-native";
import { TowerPaymentsPairFormValues } from "./types";
import { useFormContext } from "react-hook-form";

export interface TowerPaymentsPairFormProps {}

export const TowerPaymentsPairForm = ({}: TowerPaymentsPairFormProps) => {
  const { control } = useFormContext<TowerPaymentsPairFormValues>();
  return (
    <Stack vertical>
      <Card title="Pairing Code">
        <Stack vertical>
          <ControlledTextField
            control={control}
            label="Pair Code"
            placeholder="Pair Code"
            name="pairCode"
            filled={false}
          />
        </Stack>
      </Card>
    </Stack>
  );
};

TowerPaymentsPairForm.TowerPaymentsPairFormProvider =
  TowerPaymentsPairFormProvider;
